import React from "react";
import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import "./ProBadge.css";

// size: "sm" (avatar overlay) | "md" (inline pill, default)
// clickable: wraps the badge in a link to the Pro info page (default true) —
// pass false where a nested link would be invalid (e.g. already inside one).
function ProBadge({ size = "md", clickable = true }) {
  const Wrapper = clickable ? Link : "span";
  const wrapperProps = clickable ? { to: "/pro", onClick: (e) => e.stopPropagation(), title: "Greenwich Pro" } : {};

  if (size === "sm") {
    return (
      <Wrapper {...wrapperProps} className={`pro-badge pro-badge--sm${clickable ? " pro-badge--clickable" : ""}`}>
        <Crown size={10} strokeWidth={2.6} />
      </Wrapper>
    );
  }

  return (
    <Wrapper {...wrapperProps} className={`pro-badge pro-badge--md${clickable ? " pro-badge--clickable" : ""}`}>
      <Crown size={12} strokeWidth={2.6} />
      Pro
    </Wrapper>
  );
}

export default ProBadge;
